var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.27614 14.1979C3.27614 14.3947 3.33805 14.5867 3.45627 14.7508L4.04059 15.5537C4.21957 15.7998 4.62593 16 4.94877 16H7.05116C7.37291 16 7.77934 15.7999 7.95832 15.5537L8.54059 14.7511C8.64075 14.6124 8.72291 14.3645 8.72291 14.1979L8.72727 12.9728H3.27273L3.27614 14.1979ZM5.97955 2.61044e-05C2.50364 0.00979273 0 2.59269 0 5.47205C0 6.85907 0.560455 8.12357 1.485 9.09117C2.04852 9.67998 2.92841 10.911 3.26523 11.9493C3.26629 11.9571 3.26842 11.9654 3.26949 11.9737H8.73085C8.73192 11.9654 8.73405 11.9576 8.73511 11.9493C9.07176 10.911 9.95182 9.67998 10.5153 9.09117C11.4409 8.15045 12 6.88782 12 5.47205C12 2.45643 9.30341 -0.00925297 5.97955 2.61044e-05ZM6 3.00023C4.49557 3.00023 3.27273 4.12191 3.27273 5.47236C3.27273 5.7752 3.02727 6.00023 2.72727 6.00023C2.42727 6.00023 2.18182 5.7752 2.18182 5.50018C2.18182 3.56998 3.89489 2.02795 6 2.02795C6.3015 2.02795 6.54545 2.25169 6.54545 2.528C6.54545 2.80431 6.3 3.00023 6 3.00023Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.66cca867b63df3546af64eea00c3d77b.svg";
export { ForwardRef as ReactComponent };